<template>
<div id="main" class="column is-9">
	<ProfileHeader :psychic="psychic" />
		<section class="customers">
			<div class="columns">
				<div class="column">
					<div class="card">
						<header class="card-header">
						<p class="card-header-title">
							Sent Gifts
						</p>
						</header>
						<div class="card-table">
							<div class="content">
								<div class="table-container">
									<table id="allPsychics" class="table is-fullwidth is-striped">
									<thead>
									<tr>
										<th>
											<a @click="sortGifts('sent_to_name')">Member</a>
										</th>
										<th>
											<a @click="sortGifts('subject')">Subject</a>
										</th>
										<th>
											<a @click="sortGifts('date')">Sent Date</a>
										</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="gift in paginatedData" :key="gift.message_id">
										<td class=""><a @click="viewHistory(gift.user_id)">{{ gift.sent_to_name }}</a></td>
										<td class=""><a @click="selectedGift = gift">{{gift.subject}}</a></td>
										<td class="">{{formatDate(gift.date)}}</td>
									</tr>
									</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Paginator ref="paginator" :itemCount="this.gifts.length" :pageSize="this.pageSize" v-model="pageNumber" />
			</section>
			<Modal v-if="customerDetail !== null" @close="customerDetail = null">
				<span slot="title">Customer Reading History</span>
				<div class="columns" slot="body">
			<div class="column">
				<div class="card">
					<div class="card-table">
						<div class="content">
								<table class="table is-fullwidth is-striped">
									<thead>
										<tr>
											<th>
												Date/Time
											</th>
											<th>
												Minutes
											</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(detail, idx) in customerDetail" :key="idx">
											<td>
												{{ formatDate(detail.date) }}
											</td>
											<td>
												{{ detail.minutes }}
											</td>
										</tr>
									</tbody>
								</table>
						</div>
					</div>
				</div>
			</div>
		</div>
			</Modal>
			<Modal v-if="selectedGift !== null" @close="selectedGift = null">
				<span slot="title">View Gift</span>
				<div slot="body">
					<div class="field is-horizontal">
						<div class="field-body">
							<div class="control">
								To:
							</div>
							<div class="control">
								{{ selectedGift.sent_to_name }}
							</div>
						</div>
					</div>
					<div class="field is-horizontal">
						<div class="field-body">
							<div class="control">
								Minutes:
							</div>
							<div class="control">
								{{ selectedGift.minutes_sent }}
							</div>
						</div>
					</div>
					<div class="field is-horizontal">
						<div class="field-body">
							<div class="control">
								Subject:
							</div>
							<div class="control">
								{{ selectedGift.subject }}
							</div>
						</div>
					</div>
					<div class="field is-horizontal">
						<div class="field-body">
							<div class="control">
								Message:
							</div>
							<div class="control" v-html="selectedGift.body">
								{{ selectedGift.body }}
							</div>
						</div>
					</div>
				</div>
			</Modal>
			</div>
</template>

<script>
	import moment from "moment-timezone"
	import ProfileHeader from "./ProfileHeader.vue"
	import Paginator from "../Paginator.vue"
	import Modal from "../Modal.vue"

	export default {
		components: {
			ProfileHeader,
			Paginator,
			Modal
		},
		data() {
			return {
				selectedGift: null,
				customerDetail: null,
				psychic: {},
				gifts: [],
				pageNumber: 0,
				pageSize: 10,
				sortCol: "date",
				sortDir: -1
			}
		},
		methods: {
			async viewHistory(id) {
				this.customerDetail = await this.$root.$data.getters.getCustomerDetail(this.$root.$data.state, this.$route.params["id"], id)
			},
			formatDate(date) {
				return moment.tz(date, moment.tz.guess(true)).format("MM/DD/YYYY")
			},
			sortGifts(col) {
				if (this.sortCol === col) {
					this.sortDir = this.sortDir === -1 ? 1 : -1
				} else {
					this.sortCol = col
					this.sortDir = -1
				}
			}
		},
		computed: {
			paginatedData() {
				const start = this.pageNumber * this.pageSize,
					end = start + this.pageSize

				return this.sortedGifts.slice(start, end)
			},
			sortedGifts() {
				let sorted = this.gifts
				return sorted.sort((a, b) => {
					if (a[this.sortCol] < b[this.sortCol]) return -1 * this.sortDir
					if (a[this.sortCol] > b[this.sortCol]) return 1 * this.sortDir
					return 0
				})
			}
		},
		created() {
			this.$root.$data.getters.getPsychic(this.$root.$data.state, this.$route.params["id"]).then((data) => {
				this.psychic = data
			}), 
			
			this.$root.$data.getters.getSentGifts(this.$root.$data.state, this.$route.params["id"]).then((data) => {
				this.gifts = data
			})
		}
	}
</script>